"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleDeeds$ = exports.TitleDeeds$outboundSchema = exports.TitleDeeds$inboundSchema = void 0;
exports.titleDeedsToJSON = titleDeedsToJSON;
exports.titleDeedsFromJSON = titleDeedsFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
const title_js_1 = require("./title.js");
/** @internal */
exports.TitleDeeds$inboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    titles: z.array(title_js_1.Title$inboundSchema),
});
/** @internal */
exports.TitleDeeds$outboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    titles: z.array(title_js_1.Title$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TitleDeeds$;
(function (TitleDeeds$) {
    /** @deprecated use `TitleDeeds$inboundSchema` instead. */
    TitleDeeds$.inboundSchema = exports.TitleDeeds$inboundSchema;
    /** @deprecated use `TitleDeeds$outboundSchema` instead. */
    TitleDeeds$.outboundSchema = exports.TitleDeeds$outboundSchema;
})(TitleDeeds$ || (exports.TitleDeeds$ = TitleDeeds$ = {}));
function titleDeedsToJSON(titleDeeds) {
    return JSON.stringify(exports.TitleDeeds$outboundSchema.parse(titleDeeds));
}
function titleDeedsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TitleDeeds$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TitleDeeds' from JSON`);
}
//# sourceMappingURL=titledeeds.js.map